/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Municipality } from '../../models/municipality';

export interface CreateMunicipality$Params {
      body?: Municipality
}

export function createMunicipality(http: HttpClient, rootUrl: string, params?: CreateMunicipality$Params, context?: HttpContext): Observable<StrictHttpResponse<Municipality>> {
  const rb = new RequestBuilder(rootUrl, createMunicipality.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Municipality>;
    })
  );
}

createMunicipality.PATH = '/municipality';
